import React, { useContext, useMemo } from "react";
import { Box, Select } from "@flexisaf/flexibull2";
import PropTypes from "prop-types";
import styled from "styled-components";

import { SchemaContext } from "../container";

const FieldStack = styled(Box)`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0;
  padding: 0;
`;

const FieldLabel = styled.label`
  display: block;
  position: static;
  margin: 0 0 0.4rem;
  padding: 0;
  font-size: 0.78rem;
  font-weight: 500;
  letter-spacing: 0;
  text-transform: none;
  color: #5a5368;
  line-height: 1.35;
`;

export const Selector = (props) => {
  const { disabledFields, errorFields, fieldValue, updateFieldValue } =
    useContext(SchemaContext);

  const handleChange = (val) => {
    if (disabledFields.includes(props.keyField)) return;
    const value = val.value;
    updateFieldValue(props.keyField, value);
  };

  const keyedOptions = useMemo(() => {
    const options = {};
    props?.props?.options?.forEach((opt) => {
      options[opt.value] = opt;
    });
    return options;
  }, [props.props.options]);

  return (
    <FieldStack>
      {props.props?.label ? (
        <FieldLabel>
          {props.props.label}
          {props.props.required ? (
            <span style={{ color: "#ea2a8a" }}>*</span>
          ) : null}
        </FieldLabel>
      ) : null}
      <Select
        onChange={(val) => handleChange(val)}
        {...props.props}
        error={errorFields[props.keyField] || null}
        block
        label={null}
        spaceTop={0}
        value={keyedOptions[fieldValue?.[props.keyField]]}
        disable={disabledFields.includes(props.keyField)}
      />
    </FieldStack>
  );
};

Selector.defaultProps = {
  label: null,
  placeholder: "Select option",
  helper: null,
  type: "text",
  required: false,
  rules: {
    validation: null,
    before: null,
  },
};

Selector.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  helper: PropTypes.string,
  type: PropTypes.string,
  rules: PropTypes.any,
};
